"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDate = exports.isObject = exports.isUndefinedOrNull = void 0;
function isUndefinedOrNull(value) {
    return value === undefined || value === null;
}
exports.isUndefinedOrNull = isUndefinedOrNull;
/**
 * Checks if value is of type "object"
 *
 * @export
 * @param {*} value - value to check
 * @return {*}  {value is object}
 */
function isObject(value) {
    return value !== null && typeof value === "object";
}
exports.isObject = isObject;
/**
 * Checks if value is instance of Date
 *
 * @export
 * @param {*} value - value to check
 * @return {*}  {value is Date}
 */
function isDate(value) {
    return value instanceof Date;
}
exports.isDate = isDate;
//# sourceMappingURL=value-checkers.js.map